import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { getMedcallAccess } from '@/pages/medcall/medcallAccess';
import { useUser } from '@/store/useUser';
import { legacyPrograms, useLegacyAccess } from './shared';

const profileItems = legacyPrograms.map((program) => ({
  id: `dashboard-legacy-${program.key}-show-full`,
  label: `${program.label} — show_full`,
  path: `/legacy/${program.key}`,
}));

const searchItem = { id: 'dashboard-legacy-search', label: 'Legacy Participant Search', path: '/legacy/search' };
const profileItemsShared = [
  { id: 'dashboard-participant-profile-search', label: 'Participant profiles', path: '/participant/profile' },
];
const adminItems = [
  { id: 'dashboard-participant-profile-sync', label: 'Review legacy changes', path: '/admin/participant-profile-sync' },
  { id: 'dashboard-participant-multiple-enrollments', label: 'Clients in multiple programs', path: '/admin/participant-multiple-enrollments' },
];

const medcallItems = [
  { id: 'dashboard-legacy-medcall2', label: 'MedCall2', path: '/tools/medcall2' },
  { id: 'dashboard-medcall-profile-search', label: 'MedCall participant profiles', path: '/participant/profile/medcall' },
  { id: 'dashboard-medcall-profile-clients', label: 'MedCall shared clients', path: '/participant/profile/medcall/all-clients' },
];

export const LegacyDashboardSection = () => {
  const { user } = useUser();
  const canAccessMedcall = getMedcallAccess(user) !== 'none';
  const access = useLegacyAccess();
  const items = [searchItem, ...profileItemsShared, ...profileItems, ...(canAccessMedcall ? medcallItems : []), ...(access('admin:access~full') ? adminItems : [])];

  return (
    <section id="dashboard-legacy-section" aria-labelledby="dashboard-legacy-title" className="dashboard-program-section">
      <div className="mb-1">
        <h3 id="dashboard-legacy-title" className="dashboard-card-heading dashboard-program-section-heading dashboard-text-primary">
          Legacy
        </h3>
      </div>
      <div className="dashboard-program-items">
        {items.map((item) => (
          <Button
            key={item.id}
            asChild
            variant="ghost"
            size="sm"
            className="dashboard-action-row h-auto justify-start px-3 py-2 font-normal text-[var(--neutral-gray-120)] hover:bg-[var(--neutral-gray-10)] hover:text-[var(--neutral-gray-120)]"
          >
            <Link id={item.id} to={item.path}>
              <ArrowRight className="h-4 w-4 shrink-0 text-[var(--azure-primary)]" aria-hidden="true" />
              <span className="app-list-item-title dashboard-text-primary">{item.label}</span>
            </Link>
          </Button>
        ))}
        {!canAccessMedcall && (
          <p className="dashboard-card-text dashboard-text-secondary">MedCall2 requires MedCall access.</p>
        )}
      </div>
    </section>
  );
};
